<dx-button (onClick)="this.showPopup()" width="100%" height="100%" text="Trend & Pivots"
           [icon]="this.trendIcon"
           class="action-btn"
           [ngClass]="this.trendIconClass"
></dx-button>

<dx-popup
  title="Pivot Points"
  [closeOnOutsideClick]="false"
  [resizeEnabled]="true"
  [shading]="false"
  [width]="this.getPopupWidth()"
  [height]="this.getPopupHeight()"
  (onHidden)="this.onHidden()"
  titleTemplate="title"
>
  
  <div *dxTemplate="let data of 'title'" style="background: black; padding: 5px 10px">
    <div class="window-title">
      <div class="header-text">
        <div class="text">Trends & Pivots</div>
        <div class="wicks">
          <div>Wicks</div>
          <div><dx-switch [(value)]="this.wicksRowVisible" (onValueChanged)="this.onWicksRowVisibleChanged()"></dx-switch></div>
        </div>
      </div>
      <div class="icons">
        <span class="close icon">
          <i class="fas fa-times fa-lg" (click)="this.closeWindow()"></i>
        </span>
      </div>
    </div>
  </div>
  
  <div *dxTemplate="let data of 'content'" class="content">
    <div #root class="root">
      
      <div class="pivots-column">
        <div class="pivot-column up" [class.collapsed]="this.collapsibleMatrix.columnUpCollapsed">
          <div class="expanded" *ngIf="!this.collapsibleMatrix.columnUpCollapsed">
            <div class="row header">
              <div class="column">
                <div class="title up" (click)="this.toggleColumn('up')">Trend - "UP"</div>
              </div>
            </div>
            <div class="row close">
              <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.upTrendClose}"></ng-container>
              </div>
            </div>
            <div class="row wicks" *ngIf="this.wicksRowVisible">
              <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.upTrendWicks}"></ng-container>
              </div>
            </div>
          </div>
          <div class="collapsed" *ngIf="this.collapsibleMatrix.columnUpCollapsed">
              <div class="title up" (click)="this.toggleColumn( 'up')">Trend - "UP"</div>
          </div>
        </div>
        
        <div class="pivot-column down" [class.collapsed]="this.collapsibleMatrix.columnDownCollapsed">
          <div class="expanded" *ngIf="!this.collapsibleMatrix.columnDownCollapsed">
            <div class="row header">
              <div class="column">
                <div class="title down" (click)="this.toggleColumn( 'down')">Trend - "DOWN"</div>
              </div>
            </div>
            <div class="row close">
              <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.downTrendClose}"></ng-container>
              </div>
            </div>
            <div class="row wicks" *ngIf="this.wicksRowVisible">
            <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.downTrendWicks}"></ng-container>
              </div>
            </div>
          </div>
          <div class="collapsed" *ngIf="this.collapsibleMatrix.columnDownCollapsed">
            <div class="title down" (click)="this.toggleColumn( 'down')">Trend - "DOWN"</div>
          </div>
        </div>
        
        <div class="pivot-column recent" [class.collapsed]="this.collapsibleMatrix.columnRecentCollapsed">
          <div class="expanded" *ngIf="!this.collapsibleMatrix.columnRecentCollapsed">
            <div class="row header">
              <div class="column">
                <div class="title" (click)="this.toggleColumn( 'recent')">Most Recent</div>
              </div>
            </div>
            <div class="row close">
              <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.mostRecentClose}"></ng-container>
              </div>
            </div>
            <div class="row wicks" *ngIf="this.wicksRowVisible">
            <div class="column">
                <ng-container *ngTemplateOutlet="pivots; context: {$implicit: this.mostRecentWicks}"></ng-container>
              </div>
            </div>
          </div>
          <div class="collapsed" *ngIf="this.collapsibleMatrix.columnRecentCollapsed">
            <div class="title" (click)="this.toggleColumn( 'recent')">Most Recent</div>
          </div>
        </div>
        
        <div class="pivot-column trends" [class.collapsed]="this.collapsibleMatrix.columnTrendsCollapsed">
          <div class="expanded" *ngIf="!this.collapsibleMatrix.columnTrendsCollapsed">
            <div class="row header">
              <div class="column">
                <div class="title" (click)="this.toggleColumn( 'trends')">Trends</div>
              </div>
            </div>
            <div class="row body">
              <div class="column">
                <ng-container *ngTemplateOutlet="trend; context: {$implicit: this.trendData}"></ng-container>
              </div>
            </div>
          </div>
          <div class="collapsed" *ngIf="this.collapsibleMatrix.columnTrendsCollapsed">
            <div class="title" (click)="this.toggleColumn( 'trends')">Trends</div>
          </div>
        </div>
      </div>
      
    </div>
    <dx-load-panel [position]="{my: 'center', at: 'center', of: root}" [visible]="this.isLoading"></dx-load-panel>
  </div>
</dx-popup>

<ng-template #pivots let-dataObj>
  <div class="data-container">
    <table class="table">
      <thead class="header">
      <tr class="caption">
        <th colspan="3" (click)="this.toggleHeader(dataObj)">
          {{dataObj?.header}}
        </th>
      </tr>
      <tr>
        <th>Timeframe</th>
        <th>Lower Pivot</th>
        <th>Upper Pivot</th>
      </tr>
      </thead>
      <tbody class="body">
      
      <!--  1 min -->
      <tr>
        <td class="tf">1-minute</td>
        
        <td class="tf" #oneMinLower>
          {{ dataObj?.oneMinRow?.lower?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="oneMinLower" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.oneMinRow?.lower?.pivotPoint}}
              <br/>
              {{dataObj?.oneMinRow?.lower?.barTime}}
            </div>
          </dx-tooltip>
        </td>
        
        <td class="tf" #oneMinUpper>
          {{ dataObj?.oneMinRow?.upper?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="oneMinUpper" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.oneMinRow?.upper?.pivotPoint}}
              <br/>
              {{dataObj?.oneMinRow?.upper?.barTime}}
            </div>
          </dx-tooltip>
        </td>
      </tr>
      
      <!-- 5 min -->
      <tr class="alter">
        <td class="tf">5-minute</td>
        
        <td class="tf" #fiveMinLower>
          {{ dataObj?.fiveMinRow?.lower?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="fiveMinLower" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.fiveMinRow?.lower?.pivotPoint}}
              <br/>
              {{dataObj?.fiveMinRow?.lower?.barTime}}
            </div>
          </dx-tooltip>
        </td>
        
        <td class="tf" #fiveMinUpper>
          {{ dataObj?.fiveMinRow?.upper?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="fiveMinUpper" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.fiveMinRow?.upper?.pivotPoint}}
              <br/>
              {{dataObj?.fiveMinRow?.upper?.barTime}}
            </div>
          </dx-tooltip>
        </td>
      </tr>
      
      <!-- 10 min -->
      <tr>
        
        <td class="tf">10-minute</td>
        
        <td class="tf" #tenMinuteLower>
          {{ dataObj?.tenMinRow?.lower?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="tenMinuteLower" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.tenMinRow?.lower?.pivotPoint}}
              <br/>
              {{dataObj?.tenMinRow?.lower?.barTime}}
            </div>
          </dx-tooltip>
        </td>
        
        <td class="tf" #tenMinuteUpper>
          {{ dataObj?.tenMinRow?.upper?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="tenMinuteUpper" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.tenMinRow?.upper?.pivotPoint}}
              <br/>
              {{dataObj?.tenMinRow?.upper?.barTime}}
            </div>
          </dx-tooltip>
        </td>
      
      </tr>
      
      <!-- 15 min -->
      <tr class="alter">
        
        <td class="tf">15-minute</td>
        
        <td class="tf" #fifteenMinLower>
          {{ dataObj?.fifteenMinRow?.lower?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="fifteenMinLower" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.fifteenMinRow?.lower?.pivotPoint}}
              <br/>
              {{dataObj?.fifteenMinRow?.lower?.barTime}}
            </div>
          </dx-tooltip>
        </td>
        
        <td class="tf" #fifteenMinUpper>
          {{ dataObj?.fifteenMinRow?.upper?.pivotPoint | currency:'USD':'symbol':'0.0-0' }}
          <dx-tooltip [target]="fifteenMinUpper" showEvent="mouseenter" hideEvent="mouseleave">
            <div *dxTemplate="let data = data; of: 'content'">
              {{dataObj?.fifteenMinRow?.upper?.pivotPoint}}
              <br/>
              {{dataObj?.fifteenMinRow?.upper?.barTime}}
            </div>
          </dx-tooltip>
        </td>
      
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #trend let-dataObj>
  <div class="data-container">
    <table class="table">
      <thead class="header">
      <tr class="caption">
        <th colspan="3">
          {{ dataObj?.header }}
        </th>
      </tr>
      <tr>
        <th>Timeframe</th>
        <th>Trend</th>
      </tr>
      </thead>
      <tbody class="body">
      
      <!--  1 min -->
      <tr>
        <td class="tf">1-minute <span *ngIf="this.canChangeTrendSettings" (click)="this.showTrendSettings('1 min')"><i class="fas fa-cog"></i></span></td>
        <td class="tf">
          <ets-trend-icon-component [trend]="dataObj?.oneMinTrend"
                                    [info]="dataObj?.oneMinInfo"
                                    [settingsAccess]="this.canChangeTrendSettings"
          ></ets-trend-icon-component>
        </td>
      </tr>
      
      <!-- 5 min -->
      <tr class="alter">
        <td class="tf">5-minute<span *ngIf="this.canChangeTrendSettings" (click)="this.showTrendSettings('5 min')"><i
          class="fas fa-cog"></i></span></td>
        <td class="tf">
          <ets-trend-icon-component [trend]="dataObj?.fiveMinTrend"
                                    [info]="dataObj?.fiveMinInfo"
                                    [settingsAccess]="this.canChangeTrendSettings"
          ></ets-trend-icon-component>
        </td>
      </tr>
      
      <!-- 10 min -->
      <tr>
        
        <td class="tf">10-minute<span *ngIf="this.canChangeTrendSettings" (click)="this.showTrendSettings('10 min')"><i
          class="fas fa-cog"></i></span></td>
        
        <td class="tf">
          <ets-trend-icon-component [trend]="dataObj?.tenMinTrend"
                                    [info]="dataObj?.tenMinInfo"
                                    [settingsAccess]="this.canChangeTrendSettings"
          ></ets-trend-icon-component>
        </td>
      
      </tr>
      
      <!-- 15 min -->
      <tr class="alter">
        
        <td class="tf">15-minute<span *ngIf="this.canChangeTrendSettings" (click)="this.showTrendSettings('15 min')"><i
          class="fas fa-cog"></i></span></td>
        <td class="tf">
          <ets-trend-icon-component [trend]="dataObj?.fifteenMinTrend"
                                    [info]="dataObj?.fifteenMinInfo"
                                    [settingsAccess]="this.canChangeTrendSettings"
          ></ets-trend-icon-component>
        </td>
      </tr>
      </tbody>
    
    </table>
  </div>
</ng-template>

<dx-popup #trendSettingsPopup
          (onHidden)="this.hideTrendSettings()"
          [closeOnOutsideClick]="false"
          [resizeEnabled]="true"
          [shading]="true"
          [width]="320"
          [height]="310">
  <div *dxTemplate="let data of 'content'" class="content">
    <div class="trend-settings">
      <div class="parameters">
        <div class="parameter">
          <div class="label">EMA Length</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.emaLength" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
        <div class="parameter">
          <div class="label">EMA Close Confirmation Filter</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.emaCloseConfirmationFilter" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
        <div class="parameter">
          <div class="label">Slope Look Back Period</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.slopeLookBackPeriod" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
        <div class="parameter">
          <div class="label">Slope Threshold</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.slopeThreshold" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
        <div class="parameter">
          <div class="label">Range/Chop Filter Width</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.rangeChopFilterWidth" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
        <div class="parameter">
          <div class="label">Range Filter Period</div>
          <div class="input">
            <dx-number-box [(value)]="this.trendSettings.rangeFilterPeriod" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
          </div>
        </div>
      </div>
      <div class="buttons">
        <div class="button">
          <dx-button width="100%" (onClick)="this.saveTrendSettings()" text="Save"></dx-button>
        </div>
        <div class="button">
          <dx-button width="100%" (onClick)="this.hideTrendSettings()" text="Cancel"></dx-button>
        </div>
      </div>
    </div>
  </div>
</dx-popup>